import tabs from './tabs.js'
/**
 * This script is responsible for loading the channel schedule dynamically
 * using AJAX. It fetches the schedule data from the server and updates
 * the HTML content of the schedule container.
 * 
 * It requires data to be available in the global `LOADERDATA_SL` object,
 * created via the "wp_add_inline_script" function in PHP. That object should
 * contain the following properties:
 * - `ajaxUrl`: The URL to the AJAX handler.
 * - `loaderParams`: An object containing any additional parameters to be sent
 *  with the AJAX request. This object can contain:
 *  - `template`: The template to be used for the schedule (e.g., 'page', 'sidebar').
 *  - `$category`: The invintus_category value to filter the schedule by.
 */
(function() {
    const params = new URLSearchParams(LOADERDATA_SL.loaderParams ?? {});
    params.append('action', 'get_channel_schedule');
    fetch(`${LOADERDATA_SL.ajaxUrl}?${params.toString()}`)
        .then(res => {
            if (!res.ok) {
                throw new Error('Network request failed');
            }
            return res.json();
        })
        .then(json => {
            if (json.success) {
                const scheduleMarkup = json.markup;
                const scheduleContainer = document.querySelector('#schedule-container');
                if (!scheduleContainer) {
                    throw new Error('Schedule container not found');
                }
                scheduleContainer.innerHTML = scheduleMarkup;

                // Reinitialize tabs functionality after injecting the markup
                if (document.querySelector('.tabs')) {
                    tabs();
                }

            } else {
                throw new Error(json.message ?? 'Unknown error');
            }
        })
        .catch(err => {
            console.error('Error fetching schedule:', err);
        });
})();